// import React, { useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { get_category } from '../../store/services/authentication'

// const Category = () => {

//     const dispatch = useDispatch()
//     const { get_category_data, get_category_status } = useSelector(
//         (state) => state.userAuth
//       );

//     useEffect(() => {

//         dispatch(get_category())

//     }, [])

//     console.log("get_category_data",get_category_data)
//   return (
//     <div>Category</div>
//   )
// }

// export default Category

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  add_category,
  delete_category,
  get_category,
  update_category,
} from "../../store/services/authentication";
import { FaEdit, FaTrash, FaPlus, FaSave, FaTimes } from "react-icons/fa";
import { asyncStatus } from "../../utils/contants/asyncStatus";

const Category = () => {
  const dispatch = useDispatch();
  const {
    get_category_data,
    get_category_status,
    add_category_status,
    update_category_status,
    delete_category_status,
  } = useSelector((state) => state.userAuth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [newCategoryName, setNewCategoryName] = useState("");

  useEffect(() => {
    dispatch(get_category());
    setIsModalOpen(false);
  }, [dispatch, add_category_status, update_category_status,delete_category_status]);

  const handleCreate = async () => {
    if (newCategoryName.trim()) {
      await dispatch(add_category({ name: newCategoryName }));
      setNewCategoryName("");
      setIsModalOpen(false);
    }
  };

  const handleUpdate = async () => {
    if (editingCategory && newCategoryName.trim()) {
      await dispatch(
        update_category({
          id: editingCategory._id,
          name: newCategoryName,
        })
      );
      setEditingCategory(null);
      setNewCategoryName("");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
        await dispatch(delete_category(id))
    }
    // console.log(id)
  };

  const openEditModal = (category) => {
    setEditingCategory(category);
    setNewCategoryName(category.name);
    setIsModalOpen(true);
  };

  if (get_category_status === asyncStatus.LOADING) {
    return <div className="text-center py-8 text-black">Loading categories...</div>;
  }

  if (get_category_status === asyncStatus.ERROR) {
    return (
      <div className="text-center py-8 text-red-500">
        Error loading categories
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Category Management</h1>
        <button
          onClick={() => {
            setEditingCategory(null);
            setNewCategoryName("");
            setIsModalOpen(true);
          }}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center"
        >
          <FaPlus className="mr-2" /> Add Category
        </button>
      </div>

      {/* Category Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-black">
                {editingCategory ? "Edit Category" : "New Category"}
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>

            <input
              type="text"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              placeholder="Enter category name"
              className="w-full px-4 py-2 border rounded-lg mb-4"
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={editingCategory ? handleUpdate : handleCreate}
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center"
              >
                <FaSave className="mr-2" />{" "}
                {editingCategory ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Created At
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Updated At
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {get_category_data?.categories?.map((category) => (
              <tr key={category._id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {category.name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(category.createdAt).toLocaleDateString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(category.updatedAt).toLocaleDateString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    onClick={() => openEditModal(category)}
                    className="text-indigo-600 hover:text-indigo-900 mr-4"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDelete(category._id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {!get_category_data?.categories?.length && (
          <div className="text-center py-4 text-gray-500">
            No categories found
          </div>
        )}
      </div>
    </div>
  );
};

export default Category;
